<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TimeOffRow',
})

defineProps<{
  label: string
}>()
</script>

<template>
  <div class="time-off-row">
    <AppText
      name="body1"
      class="time-off-row__label"
    >
      {{ label }}
    </AppText>
    <slot />
  </div>
</template>

<style scoped lang="scss" src="./TimeOffRow.scss" />
